// extracted by mini-css-extract-plugin
export default {"error-boundary":"error-boundary--uWSzn","error-boundary__text":"error-boundary__text--_w8mf"};